import { invoicingService } from "./repository";

const resource = "/v1/process-runs";

export default {
    async getRecentRuns(count = 100) {
        return invoicingService.get(`${resource}/recent`, { params: { count } });
    }
};
